import React from 'react';

import { CompanyContext } from 'providers';

export const useCompany = () => {
  const { state, userState, fetchCompanies, ...rest } = React.useContext(CompanyContext);

  const getCompany = React.useCallback(
    (companyId = state.activeCompany) => {
      return (companyId && state.companies.find((company) => company.id === companyId)) || {};
    },
    [state.activeCompany, state.companies]
  );

  const isCompanyAdmin = React.useCallback(
    (companyId = state.activeCompany) => {
      // if super admin
      if (userState.isAdmin) {
        return true;
      }

      // or has role "admin" in company
      const company = getCompany(companyId);
      return company.member?.role === 'admin';
    },
    [state.activeCompany, getCompany]
  );

  const refreshCompanies = () => fetchCompanies(true);

  return {
    companies: state.companies,
    activeCompany: state.activeCompany,
    companiesLoaded: state.loaded,
    getCompany,
    isCompanyAdmin,
    fetchCompanies,
    refreshCompanies,
    ...rest,
  };
};
